<notification [type]="errorNotification.type" *ngIf="errorNotification.active">
    {{errorNotification.message}}
    <div *ngIf="latestOutputLink">
        <a [href]="latestOutputLink">{{wording.goToLastOutput}}</a>
    </div>
</notification>
<div class="menu" *ngIf="formValue" [class.is-latest]="isLatestOutputForAgency && !isExpired">
    <div class="header">
        <h1>{{titleResume}}</h1>
    </div>
    <div class="description" *ngIf="descriptionResume">
        <label [innerHTML]="descriptionResume"></label>
    </div>
    <div class="content">
        <div *ngFor="let quote of booking.quotes" class="quote">
            <div class="title" *ngIf="!(booking | hasOneQuote)">{{formValue.price[quote.idItem].title}}</div>
            <strong [innerHTML]="formValue.price[quote.idItem].margin * 100 | price:'EUR'"></strong>
        </div>
    </div>
    <div class="header" *ngIf="isLatestOutputForAgency">
        <h1>{{titleStep}}</h1>
    </div>
    <div class="description" *ngIf="descriptionStep && isLatestOutputForAgency">
        <label [innerHTML]="descriptionStep"></label>
    </div>
    <div class="steper" *ngIf="!isLoading && isLatestOutputForAgency">
        <div class="steperBody">
            <btn type="actionLink"
                 [label]="wording.nextStep"
                 [classList]="'no-border'"
                 (onClick)="valid()"
                 [disableIf]="disableStep"></btn>
        </div>
        <div class="steperBody">
            <btn type="actionLink"
                 [label]="wording.stepPreview"
                 [classList]="'no-border'"
                 (onClick)="preview()"
                 [disableIf]="isNotReady"></btn>
        </div>
        <div class="steperBody">
            <btn type="actionLink"
                 [label]="wording.stepGenerate"
                 [classList]="'no-border'"
                 (onClick)="generate()"
                 [disableIf]="isNotReady"></btn>
        </div>
    </div>
    <loader *ngIf="isLoading" [message]="wording.loading" type="large"></loader>

</div>
<div class="container" id="app-watabilight" *ngIf="booking">
    <watabilight-reference #ref
                           class="component"
                           [booking]="booking"
                           [customer]="form.controls[parts.customer]"
                           [sectionConfig]="sectionConfig.reference"
                           [referenceForm]="form.controls[parts.reference]"
                           (onEdit)="editBooking($event)"></watabilight-reference>

    <watabilight-price #price
                       class="component"
                       [booking]="booking"
                       [isEditable]="isLatestOutputForAgency && !isExpired"
                       [form]="form.controls[parts.price]"
                       [travellersForm]="form.controls[parts.traveller]"
                       [sectionConfig]="sectionConfig.price"
                       (onEdit)="editBooking($event)"></watabilight-price>

    <watabilight-traveller #traveller
                           class="component"
                           [travellers]="booking.travellers"
                           [isEditable]="isLatestOutputForAgency && !isExpired"
                           [form]="form.controls[parts.traveller]"
                           [sectionConfig]="sectionConfig.traveller"
                           (onEdit)="editBooking($event)"></watabilight-traveller>

    <watabilight-customer #customer
                          class="component"
                          [customer]="booking.customer"
                          [isEditable]="isLatestOutputForAgency && !isExpired"
                          [form]="form.controls[parts.customer]"
                          [sectionConfig]="sectionConfig.customer"
                          (onEdit)="editBooking($event)"></watabilight-customer>

    <watabilight-agency #agency
                        class="component"
                        [booking]="booking"
                        [isEditable]="isLatestOutputForAgency && !isExpired"
                        [form]="form.controls[parts.agency]"
                        [sectionConfig]="sectionConfig.agency"
                        (onEdit)="editBooking($event)"></watabilight-agency>

</div>
